import ApiService from '../../../../../services/apiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import compact from 'lodash/compact';
import get from 'lodash/get';
import { isNullOrEmpty } from '../../../../../utils/vuex';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
export default {
  name: 'CoreDtwinStateAggregateEdit',
  components: {
    codemirror
  },
  props: {
    lclModel: {
      type: Object,
      required: true
    },
    // is this an edit or new creation?
    mode: {
      type: String,
      required: false,
      default: () => 'edit'
    },
    tenantId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      bindings: [],
      // bindings only contains states of twins the user has access to
      // fetchBinding might return an unauthorised error for others, but those should still be kept track of
      // use this array to compare before saving to make sure no state gets deleted just because there is no access for it
      originalBindings: [],
      aggregateStateLoops: false,
      aggregateStateValue: '',
      cmOptions: {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        readOnly: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])
  },
  mounted() {
    this.originalBindings = cloneDeep(get(this.lclModel, 'properties.binding.options.aggregateStateBindingIds') || []);
    this.originalBindings.forEach(id => {
      this.fetchBinding(id);
    });
  },
  methods: {
    openDigitalTwin(dtwinId, bindingId) {
      window.open(`#/digitaltwin-mgmt/${dtwinId}?stateId=${bindingId}`, '_blank');
    },
    fetchBinding(bindingId) {
      ApiService.digitalTwinGetState(this, bindingId).then(binding => {
        this.bindings.push({
          dtwinId: binding.dtwinId,
          id: binding.id,
          key: binding.key,
          title: binding.properties.title
        });
        this.triggerBindingUiRefresh();
      }).catch(error => {
        // can fail silently, will just be filtered out
        console.error(error);
      });
    },
    triggerBindingUiRefresh: debounce(function () {
      // trigger UI refresh by cloning bindings
      this.bindings = cloneDeep(this.bindings);
      const bindingIds = compact(this.bindings.map(binding => binding.id));
      if (bindingIds.length) {
        this.refreshAggregateStateData();
      }
    }, 50, {
      leading: true
    }),
    refreshForm() {
      setTimeout(() => {
        if (this.$refs.codemirror) {
          // required workaround to get the cursor appearing at the right spot
          // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
          this.$refs.codemirror.codemirror.refresh();
          this.$refs.codemirror.codemirror.focus();
        }
      }, 50);
    },
    refreshAggregateStateData: debounce(function () {
      const bindingIds = compact(this.originalBindings);
      if (bindingIds.length) {
        let promises = [ApiService.digitalTwinStatesGetAggregateValue(this, this.$route.params.id, {
          bindingIds
        })];
        if (this.mode !== 'create') {
          promises.push(ApiService.digitalTwinStateCheckForAggregateLoop(this, this.$route.params.id, this.lclModel.id, {
            aggregateStateIds: bindingIds
          }));
        }
        Promise.all(promises).then(result => {
          if (this.mode !== 'create') {
            this.aggregateStateLoops = result[1];
          }
          this.aggregateStateValue = result[0];
          this.refreshForm();
          this.$emit('aggregatedStateValue', this.aggregateStateValue);
        }).catch(error => {
          console.error(error);
        });
      }
    }, 750, {
      leading: true
    }),
    saveState() {
      this.lclModel.properties.binding.options.aggregateStateBindingIds = [];
      this.originalBindings.forEach(id => {
        this.lclModel.properties.binding.options.aggregateStateBindingIds.push(id);
      });
    },
    addStateBinding(item) {
      this.originalBindings.push(item.id);
      this.bindings.push(item);
      this.triggerBindingUiRefresh();
    },
    removeStateBinding(item) {
      this.originalBindings = this.originalBindings.filter(id => id !== item.id);
      this.bindings = this.bindings.filter(b => b.id !== item.id);
      this.triggerBindingUiRefresh();
    },
    isNullOrEmpty(input) {
      return isNullOrEmpty(input);
    }
  }
};